import type { ReactNode } from "react";
import { Menu } from "@note-app/ui";
import { KnowledgeIcon } from "./KnowledgeIcon.tsx";

export function BrandMenu({ onOpenSettings }: { onOpenSettings: () => void }) {
  return (
    <div className="knowledge-navigation-controls">
      <Menu label="丰月笔记菜单" align="start" className="knowledge-layout-menu"
        trigger={<KnowledgeIcon name="chevron-down" />}
        items={[{ id: "settings", label: "设置", icon: <KnowledgeIcon name="settings" />, onSelect: onOpenSettings }]} />
    </div>
  );
}

/** Sections inside the mobile navigation drawer. */
export function NavigationSection({ label, children, className = "" }: {
  label: string;
  children: ReactNode;
  className?: string;
}) {
  return <div className="knowledge-navigation-section">
    <nav aria-label={label} className={className}>
      <strong>{label}</strong>
      {children}
    </nav>
  </div>;
}
